// extracted by mini-css-extract-plugin
module.exports = {"charge":"tiktokpay_charge_3ki10"};